<template>
  <div class="c-content-detail">
    <music-detail-header v-model:activeItem="activeItem" :isShowLyric="lyricData" />
    <div class="music-detail-wrap">
      <!-- :contentData="musicDetail.versionAndEdit.data" -->
      <music-detail-version-and-edit :columns="musicDetail.versionAndEdit.columns" :contentData="versionAndEditData"
        v-if="activeItem === 'version-and-edit'" />
      <track-info :data="data" :trackInfo="trackInfo" :albumData="albumData" v-if="activeItem === 'track-info'" />
      <lyric :data="lyricData" v-if="activeItem === 'lyric' && lyricData" />
      <track-divide :columns="musicDetail.track.columns" :contentData="musicDetail.track.data"
        v-if="activeItem === 'track-divide'" />
    </div>
  </div>
</template>
<script>
import { defineComponent, ref, inject, watch, onMounted } from 'vue';
import MusicDetailHeader from '@/components/MyMusic/MyMusicList/ListDetail/MusicDetail/MusicDetailHeader.vue';
import MusicDetailVersionAndEdit from '@/components/MyMusic/MyMusicList/ListDetail/MusicDetail/MusicDetailVersionAndEdit.vue';
import TrackInfo from '@/components/MyMusic/MyMusicList/ListDetail/MusicDetail/TrackInfo.vue';
import Lyric from '@/components/MyMusic/MyMusicList/ListDetail/MusicDetail/Lyric.vue';
import TrackDivide from '@/components/MyMusic/MyMusicList/ListDetail/MusicDetail/TrackDivide.vue';
import useRequest from '@/hooks/useRequest';
import { getTrackDetailAPI } from '@/api/getTrack';

// import {
//   musicDetailColumns, musicDetailContentData, trackDivideColumns, trackDivideData,
// } from '@/config/myMusic/playlistsConfig';

export default defineComponent({
  name: 'MusicContentDetail',
  components: {
    MusicDetailHeader,
    MusicDetailVersionAndEdit,
    TrackInfo,
    Lyric,
    TrackDivide,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const activeItem = ref('version-and-edit');
    const { request, response } = useRequest(getTrackDetailAPI);

    const albumData = ref({});
    const versionAndEditData = ref();
    const trackInfo = ref([]);
    const lyricData = ref('');

    const musicDetail = inject('musicDetail');

    const trackInfoMockData = [
      {
        title: 'Album',
        data: ['Beyond The Clouds'],
      },
      {
        title: 'Composer',
        data: ['Abbie Lathe [ PRS ] ', 'Al Lethbridge [ PRS ]'],
      },
      {
        title: 'Publishers',
        data: ['BBC Production Music [ PRS ]'],
      },
      {
        title: 'Labels',
        data: ['BBC Production Music'],
      },
    ];

    // const lyricMockData = [
    //   ['I’m The One'],
    //   ['I’m about to drive em crazy', 'imma do imma do imma do what I want', 'What I want'],
    //   ['Think I wanna', 'Quit for the day Imma go on a really long drive', 'Cuz I can', 'Yeah, I bought this ride'],
    // ];

    // watch(activeItem, () => {
    //   if (['track-info', 'lyric'].includes(activeItem.value)) {

    //   }
    // });

    watch(response, () => {
      const [err, res] = response.value;
      if (err) return;

      albumData.value = { ...res.getTrackDetail.detail, ...res.getTrackDetail.detail?.album };
      const { album: { albumTitleDisplay }, composers, publishers, lyricsDisplay, label } = res.getTrackDetail.detail;

      versionAndEditData.value = res.getTrackDetail.trackList.map((item) => ({
        ...item,
        ...res.getTrackDetail.detail?.album,
      }));
      const title = albumTitleDisplay || '';
      const labelName = label.labelNameDisplay || '';

      trackInfo.value = [
        {
          title: 'Album',
          data: [title],
        },
        {
          title: 'Composer',
          data: composers.map((item) => item.composer.composerName),
        },
        {
          title: 'Publishers',
          data: publishers.map((item) => item.publisher.publisherName),
        },
        {
          title: 'Labels',
          data: [labelName],
        },
      ];

      lyricData.value = lyricsDisplay;
    });

    onMounted(() => {
      request({ in: props.data.trackUid || props.data.originUid || props.data?.track.trackUid });
    });

    return {
      // musicDetailColumns,
      // musicDetailContentData,
      activeItem,
      trackInfoMockData,
      // lyricMockData,
      // trackDivideColumns,
      // trackDivideData,
      musicDetail,
      request,
      response,
      trackInfo,
      lyricData,
      versionAndEditData,
      albumData,
    };
  },
});
</script>
<style lang="scss" scoped>
.music-detail-wrap {
  background-color: $c-assist2;
  @include padding(25px 0);
}
</style>
